var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 101.25c26.096 0 47.25-21.154 47.25-47.25S80.096 6.75 54 6.75 6.75 27.904 6.75 54 27.904 101.25 54 101.25Zm0 6.75c29.823 0 54-24.177 54-54S83.823 0 54 0 0 24.177 0 54s24.177 54 54 54Z",
    fill: "#C3CAD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.045 29.867V58.2l-20.45 16.189",
    stroke: "#C3CAD9",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPending;